module.exports = __webpack_public_path__ + "static/assets/430e22d0f665cc4e18da862651410206.svg";